import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import CommonModal from '../../../../components/common-modal/CommonModal';
import UploadForm from './UploadForm';
import validate from '../../../../utils/validate';
import { uploadFormValidation } from './validation';

import scss from './UploadModal.module.scss';

function UploadModal({ isOpen, onClose, uploadedImage, onChangeImage, onSubmit }) {
  const { t } = useTranslation('id8');

  const uploadFormInitialValues = {
    description: '',
    image: uploadedImage ?? null,
  };

  const handleRecreate = (values) => {
    if (onSubmit) {
      onSubmit(values);
      onClose();
      return;
    }
  };

  const handleCancel = () => {
    onClose();
    onChangeImage(null);
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} isAnimated>
      <div className={scss.wrapper}>
        <h1 className={scss.title}>{t('addYourIdea')}</h1>
        <Form
          onSubmit={handleRecreate}
          initialValues={uploadFormInitialValues}
          subscription={{ submitting: true, pristine: true }}
          validate={(values) => validate(values, uploadFormValidation())}
          render={({ handleSubmit }) => <UploadForm onSubmit={handleSubmit} onCancel={handleCancel} />}
        />
      </div>
    </CommonModal>
  );
}

export default UploadModal;
